export default __webpack_public_path__ + "static/media/gallery_00.485db3a6.jpg";